<template>
  <div class="meet-the-prosperity" v-if="load">
    <div class="banner">
      <img :src="banner.cover" alt />
    </div>
    <div class="item-title" id="meet1">
      <h2>{{type1.name}}</h2>
    </div>
    <div class="custom-list row">
      <div class="small-12 large-6 column">
        <div class="large-square square">
          <div class="statistic-image">
            <picture>
              <img :src="type1.list[0].cover" alt typeof="foaf:Image" />
            </picture>
          </div>
          <!-- <div class="statistic-overlay">
            <div class="statistic-overlay-inner">
              <h4 class="statistic-number counter">1,289</h4>
              <div class="statistic-title">
                <span>Faculty, including full time, part time and visiting</span>
              </div>
            </div>
          </div>-->
        </div>
      </div>
      <div class="small-12 large-6 column">
        <div class="row">
          <div class="small-6 large-6 small-square square column">
            <div class="statistic-image">
              <picture>
                <img :src="type1.list[1].cover" alt typeof="foaf:Image" />
              </picture>
            </div>
            <!-- <div class="statistic-overlay">
              <div class="statistic-overlay-inner">
                <h4 class="statistic-number counter">76%</h4>
                <div class="statistic-title">
                  <span>Tenured professorial faculty</span>
                </div>
              </div>
            </div>-->
          </div>
          <div class="small-6 large-6 small-square square column">
            <div class="statistic-image">
              <picture>
                <img :src="type1.list[2].cover" alt typeof="foaf:Image" />
              </picture>
            </div>
            <!-- <div class="statistic-overlay">
              <div class="statistic-overlay-inner">
                <h4 class="statistic-number counter">76%</h4>
                <div class="statistic-title">
                  <span>Tenured professorial faculty</span>
                </div>
              </div>
            </div>-->
          </div>
        </div>

        <div class="row">
          <div class="column small-square square">
            <div class="statistic-image">
              <picture>
                <img :src="type1.list[3].cover" alt typeof="foaf:Image" />
              </picture>
            </div>
            <!-- <div class="statistic-overlay">
              <div class="statistic-overlay-inner">
                <h4 class="statistic-number counter">76%</h4>
                <div class="statistic-title">
                  <span>Tenured professorial faculty</span>
                </div>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>

    <div class="item-title" id="meet2">
      <h2>{{type2.name}}</h2>
    </div>
    <div class="custom-list row">
      <div class="small-12 large-6 column">
        <div class="large-square square">
          <div class="statistic-image">
            <picture>
              <img :src="type2.list[0].cover" alt typeof="foaf:Image" />
            </picture>
          </div>
          <!-- <div class="statistic-overlay">
            <div class="statistic-overlay-inner">
              <h4 class="statistic-number counter">1,289</h4>
              <div class="statistic-title">
                <span>Faculty, including full time, part time and visiting</span>
              </div>
            </div>
          </div>-->
        </div>
      </div>
      <div class="small-12 large-6 column">
        <div class="row">
          <div class="small-6 large-6 small-square square column">
            <div class="statistic-image">
              <picture>
                <img :src="type2.list[1].cover" alt typeof="foaf:Image" />
              </picture>
            </div>
            <!-- <div class="statistic-overlay">
              <div class="statistic-overlay-inner">
                <h4 class="statistic-number counter">76%</h4>
                <div class="statistic-title">
                  <span>Tenured professorial faculty</span>
                </div>
              </div>
            </div>-->
          </div>
          <div class="small-6 large-6 small-square square column">
            <div class="statistic-image">
              <picture>
                <img :src="type2.list[2].cover" alt typeof="foaf:Image" />
              </picture>
            </div>
            <!-- <div class="statistic-overlay">
              <div class="statistic-overlay-inner">
                <h4 class="statistic-number counter">76%</h4>
                <div class="statistic-title">
                  <span>Tenured professorial faculty</span>
                </div>
              </div>
            </div>-->
          </div>
        </div>
        <div class="row">
          <div class="small-6 large-6 small-square square column">
            <div class="statistic-image">
              <picture>
                <img :src="type2.list[3].cover" alt typeof="foaf:Image" />
              </picture>
            </div>
            <!-- <div class="statistic-overlay">
              <div class="statistic-overlay-inner">
                <h4 class="statistic-number counter">76%</h4>
                <div class="statistic-title">
                  <span>Tenured professorial faculty</span>
                </div>
              </div>
            </div>-->
          </div>
          <div class="small-6 large-6 small-square square column" v-if="type2.list[4]">
            <div class="statistic-image">
              <picture>
                <img :src="type2.list[4].cover" alt typeof="foaf:Image" />
              </picture>
            </div>
            <!-- <div class="statistic-overlay">
              <div class="statistic-overlay-inner">
                <h4 class="statistic-number counter">76%</h4>
                <div class="statistic-title">
                  <span>Tenured professorial faculty</span>
                </div>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>

    <div class="item-title" style="background: #E77500;" id="meet3">
      <h2>{{type3.name}}</h2>
    </div>
    <History :list="type3.list"></History>

    <div class="item-title" style="background: #E77500" id="meet4">
      <h2>{{type4.name}}</h2>
    </div>
    <div class="custom-list row">
      <div class="small-12 large-6 column">
        <div class="large-square square">
          <div class="statistic-image">
            <picture>
              <img :src="type4.list[0].cover" alt typeof="foaf:Image" />
            </picture>
          </div>
          <!-- <div class="statistic-overlay">
            <div class="statistic-overlay-inner">
              <h4 class="statistic-number counter">1,289</h4>
              <div class="statistic-title">
                <span>Faculty, including full time, part time and visiting</span>
              </div>
            </div>
          </div>-->
        </div>
      </div>
      <div class="small-12 large-6 column mobile-hidden">
        <div class="row">
          <div class="column small-square square">
            <div class="statistic-image">
              <picture>
                <img :src="type4.list[1].cover" alt typeof="foaf:Image" />
              </picture>
            </div>
            <!-- <div class="statistic-overlay">
              <div class="statistic-overlay-inner">
                <h4 class="statistic-number counter">76%</h4>
                <div class="statistic-title">
                  <span>Tenured professorial faculty</span>
                </div>
              </div>
            </div>-->
          </div>
          <div class="column small-square square" v-if="type4.list[2]">
            <div class="statistic-image">
              <picture>
                <img :src="type4.list[2].cover" alt typeof="foaf:Image" />
              </picture>
            </div>
            <!-- <div class="statistic-overlay">
              <div class="statistic-overlay-inner">
                <h4 class="statistic-number counter">76%</h4>
                <div class="statistic-title">
                  <span>Tenured professorial faculty</span>
                </div>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>

    <div class="item-title" id="meet5">
      <h2>{{type5.name}}</h2>
    </div>
    <div class="custom-list row">
      <div class="small-12 large-6 column">
        <div class="large-square square">
          <div class="statistic-image">
            <picture>
              <img :src="type5.list[0].cover" alt typeof="foaf:Image" />
            </picture>
          </div>
          <!-- <div class="statistic-overlay">
            <div class="statistic-overlay-inner">
              <h4 class="statistic-number counter">1,289</h4>
              <div class="statistic-title">
                <span>Faculty, including full time, part time and visiting</span>
              </div>
            </div>
          </div>-->
        </div>
      </div>
      <div class="small-12 large-6 column">
        <div class="row">
          <div class="small-6 large-6 small-square square column">
            <div class="statistic-image">
              <picture>
                <img :src="type5.list[1].cover" alt typeof="foaf:Image" />
              </picture>
            </div>
            <!-- <div class="statistic-overlay">
              <div class="statistic-overlay-inner">
                <h4 class="statistic-number counter">76%</h4>
                <div class="statistic-title">
                  <span>Tenured professorial faculty</span>
                </div>
              </div>
            </div>-->
          </div>
          <div class="small-6 large-6 small-square square column">
            <div class="statistic-image">
              <picture>
                <img :src="type5.list[2].cover" alt typeof="foaf:Image" />
              </picture>
            </div>
            <!-- <div class="statistic-overlay">
              <div class="statistic-overlay-inner">
                <h4 class="statistic-number counter">76%</h4>
                <div class="statistic-title">
                  <span>Tenured professorial faculty</span>
                </div>
              </div>
            </div>-->
          </div>
        </div>
        <div class="row">
          <div class="small-6 large-6 small-square square column">
            <div class="statistic-image">
              <picture>
                <img :src="type5.list[3].cover" alt typeof="foaf:Image" />
              </picture>
            </div>
            <!-- <div class="statistic-overlay">
              <div class="statistic-overlay-inner">
                <h4 class="statistic-number counter">76%</h4>
                <div class="statistic-title">
                  <span>Tenured professorial faculty</span>
                </div>
              </div>
            </div>-->
          </div>
          <div class="small-6 large-6 small-square square column">
            <div class="statistic-image">
              <picture>
                <img :src="type5.list[4].cover" alt typeof="foaf:Image" />
              </picture>
            </div>
            <!-- <div class="statistic-overlay">
              <div class="statistic-overlay-inner">
                <h4 class="statistic-number counter">76%</h4>
                <div class="statistic-title">
                  <span>Tenured professorial faculty</span>
                </div>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>

    <div class="item-title" id="meet6">
      <h2>{{type6.name}}</h2>
    </div>
    <div class="custom-list row">
      <div class="small-12 large-6 column">
        <div class="large-square square">
          <div class="statistic-image">
            <picture>
              <img :src="type6.list[0].cover" alt typeof="foaf:Image" />
            </picture>
          </div>
          <!-- <div class="statistic-overlay">
            <div class="statistic-overlay-inner">
              <h4 class="statistic-number counter">1,289</h4>
              <div class="statistic-title">
                <span>Faculty, including full time, part time and visiting</span>
              </div>
            </div>
          </div>-->
        </div>
      </div>
      <div class="small-12 large-6 column mobile-hidden">
        <div class="row">
          <div class="column small-square square">
            <div class="statistic-image">
              <picture>
                <img :src="type6.list[1].cover" alt typeof="foaf:Image" />
              </picture>
            </div>
            <!-- <div class="statistic-overlay">
              <div class="statistic-overlay-inner">
                <h4 class="statistic-number counter">76%</h4>
                <div class="statistic-title">
                  <span>Tenured professorial faculty</span>
                </div>
              </div>
            </div>-->
          </div>
        </div>
        <div class="row">
          <div class="column small-square square">
            <div class="statistic-image">
              <picture>
                <img :src="type6.list[2].cover" alt typeof="foaf:Image" />
              </picture>
            </div>
            <!-- <div class="statistic-overlay">
              <div class="statistic-overlay-inner">
                <h4 class="statistic-number counter">76%</h4>
                <div class="statistic-title">
                  <span>Tenured professorial faculty</span>
                </div>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import History from "@/components/meetTheProsperity/history";
import { MeetInfo } from "@/api/index";
export default {
  components: {
    History,
  },
  data() {
    return {
      load: false,
      banner: null,
      type1: null,
      type2: null,
      type3: null,
      type4: null,
      type5: null,
      type6: null,
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
    MeetInfo((res) => {
      this.load = true;
      this.$emit("complete", true);
      if (res.code == 0) {
        this.banner = res.data.banner;
        this.type1 = res.data.list.find((item) => item.type === 1);
        this.type2 = res.data.list.find((item) => item.type === 2);
        this.type3 = res.data.list.find((item) => item.type === 3);
        this.type4 = res.data.list.find((item) => item.type === 4);
        this.type5 = res.data.list.find((item) => item.type === 5);
        this.type6 = res.data.list.find((item) => item.type === 6);
      }
    });
  },
  mounted() {
    document.getElementById("meetTab").classList.add("is-active");
  },
};
</script>
<style lang='less' scoped>
// 重置每页面banner的样式
@media (min-aspect-ratio: 13/9) {
  .banner {
    width: 100%;
    min-height: 34vw;
    max-height: 34vw;
    height: 34vw;
  }
}
@media (min-aspect-ratio: 10/9) {
  .banner {
    width: 100%;
    min-height: 41vw;
    max-height: 41vw;
    height: 41vw;
  }
}
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}

.item-title {
  background: #000;
  color: #fff;
  padding: 2rem 3.125rem;
}
.custom-list {
  background: #000;
  .row {
    margin-left: 0;
    margin-right: 0;
  }
  .column {
    padding-left: 0;
    padding-right: 0;
  }
  .small-square {
    height: 25vw;
  }
  .square {
    position: relative;
    .statistic-image {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        max-width: 100%;
        -webkit-filter: gray;
        filter: gray;
        -webkit-filter: grayscale(100%) brightness(0.6);
        filter: grayscale(100%) brightness(0.6);
        -webkit-transition: -webkit-filter 0.15s ease;
        transition: -webkit-filter 0.15s ease;
        transition: filter 0.15s ease;
        transition: filter 0.15s ease, -webkit-filter 0.15s ease;
        &:hover {
          -webkit-filter: grayscale(0) brightness(1);
          filter: grayscale(0) brightness(1);
        }
      }
    }
    .statistic-overlay-inner {
      display: block;
      position: absolute;
      margin: 2rem;
      left: 0;
      bottom: 0;
      h4 {
        color: #e77500;
      }
      .statistic-title {
        font-size: 1.125rem;
        color: #fff;
      }
    }
  }
  .large-square {
    height: 50vw;
  }
}

@media print, screen and (min-width: 40em) {
  .large-square h4.statistic-number {
    font-size: 3.75rem;
    line-height: 3.75rem;
  }
  .small-square h4.statistic-number {
    font-size: 1.125rem;
    line-height: 1.125rem;
  }
}
@media print, screen and (min-width: 64.0625em) {
  .large-square h4.statistic-number {
    font-size: 5rem;
    line-height: 5rem;
  }
  .small-square h4.statistic-number {
    font-size: 2.5rem;
    line-height: 2.5rem;
  }
}
@media print, screen and (min-width: 80em) {
  .large-square h4.statistic-number {
    font-size: 7.5rem;
    line-height: 7.5rem;
  }
  .small-square h4.statistic-number {
    font-size: 3.75rem;
    line-height: 3.75rem;
  }
}
@media print, screen and (max-width: 40em) {
  .item-title {
    padding: 1rem;
    h2 {
      font-size: 1.2rem;
    }
  }
  .mobile-hidden {
    display: none;
  }
}
</style>